/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created on Mon Feb 28 2022 16:48:22 GMT+0100 (heure normale d’Europe centrale).
 *
 * Version : Generator 2.0.9 / Datatable 1.0.1
 */

import {MOEntity} from './MOEntity';


/**
 * Notes des Rouleaux Entity.
 */
export class RouleauNote extends MOEntity {
    /**
     * Code Rouleau
     */
    private _codeRouleau: string;
    /**
     * Note sol lourd rappuyage en ligne
     */
    private _solLourdRappuyageLigne: number;
    /**
     * Note sol lourd insensible aucollage
     */
    private _solLourdInsCollage: number;
    /**
     * Note sol lourd insensible aux pierres
     */
    private _solLourdInsPierres: number;
    /**
     * Note sol lourd nivellement
     */
    private _solLourdNivellement: number;
    /**
     * Note sol lourd contrôle profondeur
     */
    private _solLourdCtrlProf: number;
    /**
     * Note sol lourd rappuyage
     */
    private _solLourdRappuyage: number;
    /**
     * Note sol lourd roulage
     */
    private _solLourdRoulage: number;
    /**
     * Note sol lourd emiettement
     */
    private _solLourdEmiettement: number;
    /**
     * Note sol moyen rappuyage en ligne
     */
    private _solMoyenRappuyageLigne: number;
    /**
     * Note sol moyen insensible aucollage
     */
    private _solMoyenInsCollage: number;
    /**
     * Note sol moyen insensible aux pierres
     */
    private _solMoyenInsPierres: number;
    /**
     * Note sol moyen nivellement
     */
    private _solMoyenNivellement: number;
    /**
     * Note sol moyen contrôle profondeur
     */
    private _solMoyenCtrlProf: number;
    /**
     * Note sol moyen rappuyage
     */
    private _solMoyenRappuyage: number;
    /**
     * Note sol moyen roulage
     */
    private _solMoyenRoulage: number;
    /**
     * Note sol moyen emiettement
     */
    private _solMoyenEmiettement: number;
    /**
     * Note sol léger rappuyage en ligne
     */
    private _solLegerRappuyageLigne: number;
    /**
     * Note sol léger insensible aucollage
     */
    private _solLegerInsCollage: number;
    /**
     * Note sol léger insensible aux pierres
     */
    private _solLegerInsPierres: number;
    /**
     * Note sol léger nivellement
     */
    private _solLegerNivellement: number;
    /**
     * Note sol léger contrôle profondeur
     */
    private _solLegerCtrlProf: number;
    /**
     * Note sol léger rappuyage
     */
    private _solLegerRappuyage: number;
    /**
     * Note sol léger roulage
     */
    private _solLegerRoulage: number;
    /**
     * Note sol léger emiettement
     */
    private _solLegerEmiettement: number;
    /**
     * Note moyenne rappuyage en ligne
     */
    private _generalRappuyageLigne: number;
    /**
     * Note moyenne insensible aucollage
     */
    private _generalInsCollage: number;
    /**
     * Note moyenne insensible aux pierres
     */
    private _generalInsPierres: number;
    /**
     * Note moyenne nivellement
     */
    private _generalNivellement: number;
    /**
     * Note moyenne contrôle profondeur
     */
    private _generalCtrlProf: number;
    /**
     * Note moyenne rappuyage
     */
    private _generalRappuyage: number;
    /**
     * Note moyenne roulage
     */
    private _generalRoulage: number;
    /**
     * Note moyenne emiettement
     */
    private _generalEmiettement: number;

    /**
     * Method called before the creation
     */
    protected createBefore(): void {
    }

    /**
     * Method called before the update
     */
    protected synchroBefore(): void {
    }

    /**
     * Method called before the synchronization
     */
    protected updateBefore(): void {
    }

    /**
     * Getter Code Rouleau
     */
    public get codeRouleau(): string {
        return this._codeRouleau;
    }

    /**
     * Setter Code Rouleau
     */
    public set codeRouleau(value: string) {
        this._codeRouleau = value;
    }

    /**
     * Getter Note sol lourd rappuyage en ligne
     */
    public get solLourdRappuyageLigne(): number {
        return this._solLourdRappuyageLigne;
    }

    /**
     * Setter Note sol lourd rappuyage en ligne
     */
    public set solLourdRappuyageLigne(value: number) {
        this._solLourdRappuyageLigne = value;
    }

    /**
     * Getter Note sol lourd insensible aucollage
     */
    public get solLourdInsCollage(): number {
        return this._solLourdInsCollage;
    }

    /**
     * Setter Note sol lourd insensible aucollage
     */
    public set solLourdInsCollage(value: number) {
        this._solLourdInsCollage = value;
    }

    /**
     * Getter Note sol lourd insensible aux pierres
     */
    public get solLourdInsPierres(): number {
        return this._solLourdInsPierres;
    }

    /**
     * Setter Note sol lourd insensible aux pierres
     */
    public set solLourdInsPierres(value: number) {
        this._solLourdInsPierres = value;
    }

    /**
     * Getter Note sol lourd nivellement
     */
    public get solLourdNivellement(): number {
        return this._solLourdNivellement;
    }

    /**
     * Setter Note sol lourd nivellement
     */
    public set solLourdNivellement(value: number) {
        this._solLourdNivellement = value;
    }

    /**
     * Getter Note sol lourd contrôle profondeur
     */
    public get solLourdCtrlProf(): number {
        return this._solLourdCtrlProf;
    }

    /**
     * Setter Note sol lourd contrôle profondeur
     */
    public set solLourdCtrlProf(value: number) {
        this._solLourdCtrlProf = value;
    }

    /**
     * Getter Note sol lourd rappuyage
     */
    public get solLourdRappuyage(): number {
        return this._solLourdRappuyage;
    }

    /**
     * Setter Note sol lourd rappuyage
     */
    public set solLourdRappuyage(value: number) {
        this._solLourdRappuyage = value;
    }

    /**
     * Getter Note sol lourd roulage
     */
    public get solLourdRoulage(): number {
        return this._solLourdRoulage;
    }

    /**
     * Setter Note sol lourd roulage
     */
    public set solLourdRoulage(value: number) {
        this._solLourdRoulage = value;
    }

    /**
     * Getter Note sol lourd emiettement
     */
    public get solLourdEmiettement(): number {
        return this._solLourdEmiettement;
    }

    /**
     * Setter Note sol lourd emiettement
     */
    public set solLourdEmiettement(value: number) {
        this._solLourdEmiettement = value;
    }

    /**
     * Getter Note sol moyen rappuyage en ligne
     */
    public get solMoyenRappuyageLigne(): number {
        return this._solMoyenRappuyageLigne;
    }

    /**
     * Setter Note sol moyen rappuyage en ligne
     */
    public set solMoyenRappuyageLigne(value: number) {
        this._solMoyenRappuyageLigne = value;
    }

    /**
     * Getter Note sol moyen insensible aucollage
     */
    public get solMoyenInsCollage(): number {
        return this._solMoyenInsCollage;
    }

    /**
     * Setter Note sol moyen insensible aucollage
     */
    public set solMoyenInsCollage(value: number) {
        this._solMoyenInsCollage = value;
    }

    /**
     * Getter Note sol moyen insensible aux pierres
     */
    public get solMoyenInsPierres(): number {
        return this._solMoyenInsPierres;
    }

    /**
     * Setter Note sol moyen insensible aux pierres
     */
    public set solMoyenInsPierres(value: number) {
        this._solMoyenInsPierres = value;
    }

    /**
     * Getter Note sol moyen nivellement
     */
    public get solMoyenNivellement(): number {
        return this._solMoyenNivellement;
    }

    /**
     * Setter Note sol moyen nivellement
     */
    public set solMoyenNivellement(value: number) {
        this._solMoyenNivellement = value;
    }

    /**
     * Getter Note sol moyen contrôle profondeur
     */
    public get solMoyenCtrlProf(): number {
        return this._solMoyenCtrlProf;
    }

    /**
     * Setter Note sol moyen contrôle profondeur
     */
    public set solMoyenCtrlProf(value: number) {
        this._solMoyenCtrlProf = value;
    }

    /**
     * Getter Note sol moyen rappuyage
     */
    public get solMoyenRappuyage(): number {
        return this._solMoyenRappuyage;
    }

    /**
     * Setter Note sol moyen rappuyage
     */
    public set solMoyenRappuyage(value: number) {
        this._solMoyenRappuyage = value;
    }

    /**
     * Getter Note sol moyen roulage
     */
    public get solMoyenRoulage(): number {
        return this._solMoyenRoulage;
    }

    /**
     * Setter Note sol moyen roulage
     */
    public set solMoyenRoulage(value: number) {
        this._solMoyenRoulage = value;
    }

    /**
     * Getter Note sol moyen emiettement
     */
    public get solMoyenEmiettement(): number {
        return this._solMoyenEmiettement;
    }

    /**
     * Setter Note sol moyen emiettement
     */
    public set solMoyenEmiettement(value: number) {
        this._solMoyenEmiettement = value;
    }

    /**
     * Getter Note sol léger rappuyage en ligne
     */
    public get solLegerRappuyageLigne(): number {
        return this._solLegerRappuyageLigne;
    }

    /**
     * Setter Note sol léger rappuyage en ligne
     */
    public set solLegerRappuyageLigne(value: number) {
        this._solLegerRappuyageLigne = value;
    }

    /**
     * Getter Note sol léger insensible aucollage
     */
    public get solLegerInsCollage(): number {
        return this._solLegerInsCollage;
    }

    /**
     * Setter Note sol léger insensible aucollage
     */
    public set solLegerInsCollage(value: number) {
        this._solLegerInsCollage = value;
    }

    /**
     * Getter Note sol léger insensible aux pierres
     */
    public get solLegerInsPierres(): number {
        return this._solLegerInsPierres;
    }

    /**
     * Setter Note sol léger insensible aux pierres
     */
    public set solLegerInsPierres(value: number) {
        this._solLegerInsPierres = value;
    }

    /**
     * Getter Note sol léger nivellement
     */
    public get solLegerNivellement(): number {
        return this._solLegerNivellement;
    }

    /**
     * Setter Note sol léger nivellement
     */
    public set solLegerNivellement(value: number) {
        this._solLegerNivellement = value;
    }

    /**
     * Getter Note sol léger contrôle profondeur
     */
    public get solLegerCtrlProf(): number {
        return this._solLegerCtrlProf;
    }

    /**
     * Setter Note sol léger contrôle profondeur
     */
    public set solLegerCtrlProf(value: number) {
        this._solLegerCtrlProf = value;
    }

    /**
     * Getter Note sol léger rappuyage
     */
    public get solLegerRappuyage(): number {
        return this._solLegerRappuyage;
    }

    /**
     * Setter Note sol léger rappuyage
     */
    public set solLegerRappuyage(value: number) {
        this._solLegerRappuyage = value;
    }

    /**
     * Getter Note sol léger roulage
     */
    public get solLegerRoulage(): number {
        return this._solLegerRoulage;
    }

    /**
     * Setter Note sol léger roulage
     */
    public set solLegerRoulage(value: number) {
        this._solLegerRoulage = value;
    }

    /**
     * Getter Note sol léger emiettement
     */
    public get solLegerEmiettement(): number {
        return this._solLegerEmiettement;
    }

    /**
     * Setter Note sol léger emiettement
     */
    public set solLegerEmiettement(value: number) {
        this._solLegerEmiettement = value;
    }

    /**
     * Getter Note moyenne rappuyage en ligne
     */
    public get generalRappuyageLigne(): number {
        return this._generalRappuyageLigne;
    }

    /**
     * Setter Note moyenne rappuyage en ligne
     */
    public set generalRappuyageLigne(value: number) {
        this._generalRappuyageLigne = value;
    }

    /**
     * Getter Note moyenne insensible aucollage
     */
    public get generalInsCollage(): number {
        return this._generalInsCollage;
    }

    /**
     * Setter Note moyenne insensible aucollage
     */
    public set generalInsCollage(value: number) {
        this._generalInsCollage = value;
    }

    /**
     * Getter Note moyenne insensible aux pierres
     */
    public get generalInsPierres(): number {
        return this._generalInsPierres;
    }

    /**
     * Setter Note moyenne insensible aux pierres
     */
    public set generalInsPierres(value: number) {
        this._generalInsPierres = value;
    }

    /**
     * Getter Note moyenne nivellement
     */
    public get generalNivellement(): number {
        return this._generalNivellement;
    }

    /**
     * Setter Note moyenne nivellement
     */
    public set generalNivellement(value: number) {
        this._generalNivellement = value;
    }

    /**
     * Getter Note moyenne contrôle profondeur
     */
    public get generalCtrlProf(): number {
        return this._generalCtrlProf;
    }

    /**
     * Setter Note moyenne contrôle profondeur
     */
    public set generalCtrlProf(value: number) {
        this._generalCtrlProf = value;
    }

    /**
     * Getter Note moyenne rappuyage
     */
    public get generalRappuyage(): number {
        return this._generalRappuyage;
    }

    /**
     * Setter Note moyenne rappuyage
     */
    public set generalRappuyage(value: number) {
        this._generalRappuyage = value;
    }

    /**
     * Getter Note moyenne roulage
     */
    public get generalRoulage(): number {
        return this._generalRoulage;
    }

    /**
     * Setter Note moyenne roulage
     */
    public set generalRoulage(value: number) {
        this._generalRoulage = value;
    }

    /**
     * Getter Note moyenne emiettement
     */
    public get generalEmiettement(): number {
        return this._generalEmiettement;
    }

    /**
     * Setter Note moyenne emiettement
     */
    public set generalEmiettement(value: number) {
        this._generalEmiettement = value;
    }

}
